import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardSummary = ({ metrics }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="px-4 py-3 md:px-6 md:py-4 border-b border-border">
        <h2 className="text-lg md:text-xl font-semibold text-foreground">Dashboard Summary</h2>
        <p className="text-xs md:text-sm text-muted-foreground mt-1 font-caption">Your recent activity and available resources</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 p-4 md:p-6">
        {metrics?.map((metric) => (
          <div
            key={metric?.id}
            className="bg-background border border-border rounded-lg p-4 hover:shadow-md transition-all duration-250"
          >
            <div className="flex items-center gap-3 mb-3">
              <div 
                className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center bg-primary/10"
              >
                <Icon name={metric?.icon} size={20} className="text-primary" />
              </div>
            </div>
            <div className="text-2xl md:text-3xl font-semibold text-foreground mb-1 whitespace-nowrap">
              {metric?.value}
            </div>
            <div className="text-xs md:text-sm text-muted-foreground font-caption">
              {metric?.label}
            </div>
            {metric?.change && (
              <div className={`flex items-center gap-1 mt-2 text-xs font-medium ${
                metric?.changeType === 'increase' ? 'text-success' : 'text-muted-foreground'
              }`}>
                <Icon 
                  name={metric?.changeType === 'increase' ? 'TrendingUp' : 'Minus'} 
                  size={12} 
                />
                <span>{metric?.change}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardSummary;